const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const HOUR_MS = 60 * 60 * 1000
const HOURS_PER_DAY = 24
const HOURS_PER_WEEK = 7 * HOURS_PER_DAY
const EXAMPLE_FRIDAY_11AM = Date.UTC(2026, 0, 9, 11)

export const noticeHours = (amount, unit) => (Number(amount) || 0) * (unit === 'days' ? HOURS_PER_DAY : 1)

const clock = date => {
  const hour = date.getUTCHours()
  return `${hour % 12 || 12}${hour < 12 ? 'am' : 'pm'}`
}

export function noticeExample(amount, unit) {
  const hours = noticeHours(amount, unit)
  if (hours <= 0 || hours >= HOURS_PER_WEEK) return ''
  const cutoff = new Date(EXAMPLE_FRIDAY_11AM - hours * HOUR_MS)
  return `For example, orders for a Friday 11am delivery close ${WEEKDAYS[cutoff.getUTCDay()]} at ${clock(cutoff)}.`
}

export function upcomingDatesNote(count) {
  if (!count) return ''
  return `Saving moves the order cutoff on your ${count} upcoming delivery ${count === 1 ? 'date' : 'dates'}.`
}
